import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=abd940a0&scoped=true&"
import script from "./registration.vue?vue&type=script&lang=js&"
export * from "./registration.vue?vue&type=script&lang=js&"
import style0 from "./registration.vue?vue&type=style&index=0&id=abd940a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd940a0",
  null
  
)

export default component.exports